import {CatalogContext} from "../catalog_context";

export const handleSubmitCb = (e, product, cb, addParams) => {
    if(addParams){
        e.preventDefault();
        cb(product.key);
    } else {
        cb();
    }
    // Check if user has provided his profile
    // if(catalogModule.isValidAddress()) {
    //     if(addParams){
    //         e.preventDefault();
    //         cb(product.key);
    //     } else {
    //         cb();
    //     }
    // } else {
    //     if(catalogModule.isAuthenticated()){
    //         e.preventDefault();
    //         setUserProfileAddress(null, null, null, null, null, null, null, null, product.key);
    //     }
    // }
}

export const formatEuro = () => {
    return <sup>{String.fromCharCode(8364)}</sup>;
}

export const formatDecimal = (value, fixed) => {
    let re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return parseFloat(value.toString().match(re)[0]);
}

export const getBtnTheme = () => {
    const appTheme = getAppTheme();
    let btnStyle;
    if(appTheme === 'services'){
        btnStyle = "anp-button";
    } else if(appTheme === 'manager'){
        btnStyle = "anm-button";
    } else {
        btnStyle = "anp-button";
    }

    return btnStyle;
}

export const getCatalogBtn = () => {
    const appTheme = getAppTheme();
    const btnStyle = getBtnTheme();
    let btnWidth = 'full-width';
    if(appTheme === 'services'){
        btnWidth = window.location.pathname.includes("bundle") ? 'half-width' : 'full-width';
    }
    return `${btnStyle} is-primary ${btnWidth}`;
}

export const getAppTheme = () => {
    const catalogCtx = React.useContext(CatalogContext);
    const { catalog_data } = catalogCtx;
    return catalog_data.app_theme
}

export const isSourceApp = (source) => {
    return source === "google" || source === "itunes" || source === "huawei";
}

export const isAboutExpire30 = (exp_date_ts) => {
    let expirationDate = new Date(exp_date_ts * 1000);
    let currentDate = new Date();
    return ((expirationDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)) <= 30;
}

function isTomorrow (date) {
    if (!(date instanceof Date)) {
        throw new Error('Invalid argument: you must provide a "date" instance')
    }

    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    return date.getDate() === tomorrow.getDate() &&
        date.getMonth() === tomorrow.getMonth() &&
        date.getFullYear() === tomorrow.getFullYear()
}

export const isAboutExpire1 = (exp_date_ts) => {
    let expirationDate = new Date(exp_date_ts * 1000);
    return isTomorrow(expirationDate);
}
